const layout = () => import("../../internal/dashboard/layoutV2.vue");
const colaborators = () => import("./colaboratorsV2.vue");
const manageColaborator = () => import('./manageColaborator.vue')


const colaboratorsRoutes = {
  component: layout,
  children: [
    {
      path: "/colaborators",
      name: "colaborators",
      meta: {
        title: "colaborators",
        requiresAuth: true,
      },
      component: colaborators,
    },
    {
      path: '/colaborators/manage',
      name: 'colaboratorsManage',
      component: manageColaborator,
    
      meta: {
        title: "colaborators",
        requiresAuth: true,
      },
    }
  ],
  
};

export default colaboratorsRoutes;